import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { InputComponent } from '@shared/components/input/input.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

import { CloseMonthAuditPackageConfirmationComponent } from './close-month-audit-package-confirmation/close-month-audit-package-confirmation.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CloseMonthAuditPackageConfirmationComponent,
    InputComponent,
    FormsModule,
    ReactiveFormsModule,
    CheckboxComponent,
    AsyncPipe,
  ],
  styles: [],
  templateUrl: './quarter-close-dialog.component.html',
})
export class QuarterCloseDialogComponent {
  private ld = inject(LaunchDarklyService);
  private workflowQuery = inject(WorkflowQuery);

  isQuarterCloseEnabled$ = this.workflowQuery.isQuarterCloseEnabled$;
  ref = inject<
    CustomOverlayRef<
      | undefined
      | {
          note: string;
          sendToNetsuite: boolean;
        },
      {
        formatted_current_month: string;
      }
    >
  >(CustomOverlayRef);
  sendToNetsuite = new UntypedFormControl(false, Validators.required);
  showNetsuiteMessage$: Observable<boolean>;
  steps = [
    'Trial Timeline is accurate',
    'Site, Patient, & Custom Curves are up to date',
    'Patient Tracker is up to date',
    'Email Vendor Estimate for Trailing Month WP',
  ];
  textarea = new UntypedFormControl('', Validators.required);

  close(bool: boolean) {
    const note = this.textarea.value;
    const sendToNetsuite = this.sendToNetsuite.value;

    if (bool && !note) {
      this.textarea.markAsTouched();
      this.textarea.markAsDirty();
      this.textarea.updateValueAndValidity();

      return;
    }

    this.ref.close({
      note,
      sendToNetsuite,
    });
  }

  constructor() {
    const ld = this.ld;

    this.showNetsuiteMessage$ = ld.select$((flags) => flags.netsuite_integration_month_close);
  }
}
